import styled from 'styled-components';
import { media } from '../breakpoints';

const GUTTER_PX = 24;

/** Shared page-width wrapper used to keep consistent max-width and breakpoints. */
export const PageContainer = styled.div`
	width: 100%;
	padding: 0 clamp(16px, 1.7vw, 32px);
`;

export const Grid = styled.div`
	display: grid;
	column-gap: ${GUTTER_PX}px;
	row-gap: ${GUTTER_PX}px;
	grid-template-columns: repeat(4, minmax(0, 1fr));

	${media.tablet} {
		grid-template-columns: repeat(8, minmax(0, 1fr));
	}

	${media.desktop} {
		grid-template-columns: repeat(12, minmax(0, 1fr));
	}
`;
